import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import webinar from './webinar_modal.png';
import { Row } from '@design-system/components/grid/grid';
import { externalUrls } from '../mappers';

export const WebinarModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Everything you need: Getting started webinar 🤩"
      modalClassName="w-full md:max-w-[700px]"
      primaryCta={{
        caption: 'Join webinar',
        onClick: () => {
          window.open(externalUrls['webinar'], '_blank');
        },
      }}
      secondaryCta={{
        caption: 'Skip for now',
        onClick: onClose,
      }}
    >
      <Typography variant="body" fontWeight="medium">
        Attend our free weekly webinar to give you a game plan and help fast
        track your launch.
      </Typography>
      <Row gap="l" className="mx-4">
        <img src={webinar} />
      </Row>
    </Modal>
  );
};
